/** @format */

const localDict = {
  '告警服务升级了，查看如何': 'The alert service has been upgraded. Please check how to ',
  配置告警策略: 'configure alert policies',
  设置默认策略: 'Set Default Policy',
  禁用状态下的策略不可设置为默认策略: 'Disabled policies cannot be set as the default policy',
  项目关联的策略不可设置为默认策略:
    'Policies associated with projects cannot be set as the default policy',
  '是否确认设置当前默认策略？': 'Are you sure you want to set the current policy as the default?',
  '每类产品下只允许有一项默认策略。若当前产品下已有默认策略，开启后，之前的默认策略会变为“非默认”状态':
    'Only one default policy is allowed per product type. If a default policy already exists for the current product, the previous one will become non-default after enabling this setting',
  确认设置: 'Confirm Setting',
  取消默认策略: 'Cancel Default Policy',
  默认策略不能删除: 'Default policies cannot be deleted',
  '确认删除当前策略？': 'Are you sure you want to delete the current policy?',
  策略删除成功: 'Policy deleted successfully',
  策略删除失败: 'Policy deletion failed',
  默认策略不能禁用: 'Default policies cannot be disabled',
  关联模板名称: 'Associated Template Name',
  近5分钟: 'Last 5 Minutes',
  近3小时: 'Last 3 Hours',
  '共{n}个视图': 'Total {n} Views',
  我的收藏: 'My Favorites',
  请输入产品名称进行搜索: 'Please enter the product name to search',
  周期聚合方式: 'Aggregation Method',
  维度: 'Dimensions',
  默认全部维度: 'Default All Dimensions',
  默认为全部: 'Default All',
  批量解绑: 'Batch Unbind',
  实例ID: 'Instance ID',
  请选择事件: 'Please select an event',
  选择模版: 'Select Template',
  手动匹配: 'Manual Matching',
  触发条件: 'Trigger Condition',
  累计触发: 'Accumulated Trigger',
  触发: 'Trigger',
  触发方式: 'Trigger Method',
  条件触发模版: 'Conditional Trigger Template',
  请选择条件触发模版: 'Please select a conditional trigger template',
  新建模板: 'Create Template',
  编辑模板: 'Edit Template',
  在5分钟内: 'In 5 minutes',
  在10分钟内: 'In 10 minutes',
  在30分钟内: 'In 30 minutes',
  在60分钟内: 'In 60 minutes',
  在3小时内: 'In 3 hours',
  在6小时内: 'In 6 hours',
  在12小时内: 'In 12 hours',
  在24小时内: 'In 24 hours',
  告警一次: 'Alert Once Every',
  间隔5分钟告警一次: '5 minutes',
  间隔10分钟告警一次: '10 minutes',
  间隔15分钟告警一次: '15 minutes',
  间隔30分钟告警一次: '30 minutes',
  间隔1小时告警一次: '1 hour',
  间隔3小时告警一次: '3 hours',
  间隔6小时告警一次: '6 hours',
  间隔12小时告警一次: '12 hours',
  间隔1天告警一次: '1 day',
  '共{x}个资源告警数': 'Total {x} Resource Alerts',
  所属项目: 'Project',
  标签: 'Tag',
  全部: 'All',
  告警策略名称: 'Alert Policy Name',
  触发时间: 'Trigger Time',
  关联硬盘ID: 'Associated Disk ID',
  正在告警资源: 'Alarming Resources',
  下载成功: 'Download Success',
  所选产品暂无数据: 'No data for the selected product',
  '输入实例ID、实例名称': 'Please enter the instance ID or instance name',
  关联云硬盘: 'Associated Cloud Disk',
  云硬盘ID: 'Disk ID',
  触发条件模版: 'Condition Template',
  模版名称: 'Template Name',
  模板描述: 'Template Description',
  绑定策略数: 'Bound Policies',
  最后修改时间: 'Last Modified Time',
  确定删除所选触发条件模板:
    'Are you sure you want to delete the selected trigger condition template?',
  请输入模版名称: 'Please enter the template name',
  展开全部: 'Expand All',
  收起: 'Collapse',
  '共{n}条': 'Total {n} Items',
  请正确填写阈值告警规则: 'Please fill in the threshold alarm rule correctly',
  至少填写一条告警规则: 'Please fill in at least one alarm rule',
  编辑触发条件模版: 'Edit Trigger Condition Template',
  新建触发条件模版: 'Create Trigger Condition Template',
  次则: 'time then',
  批量编辑: 'Batch Edit',
  批量删除: 'Batch Delete',
  请至少保留一条事件: 'Please keep at least one event',
  请选择事件名称: 'Please select an event',
  '点击“确定”后，配置策略将对已勾选的多个事件生效':
    'After clicking “Confirm”, the configured policy will take effect for multiple selected events.',
  告警屏蔽: 'Alarm Shielding',
  规则名称: 'Rule Name',
  未启用: 'Disabled',
  启用中: 'Enabled',
  生效中: 'In Effect',
  已失效: 'Expired',
  事件: 'Event',
  全部指标: 'All Metrics',
  全部事件: 'All Events',
  屏蔽条件: 'Shielding Conditions',
  绑定实例: 'Bound Instances',
  规则描述: 'Rule Description',
  生效时段: 'Effective Period',
  永久屏蔽: 'Permanent Shielding',
  绝对时间范围: 'Absolute Time Range',
  循环日期: 'Cycle Date',
  时间范围: 'Time Range',
  永久: 'Permanent',
  是否启用: 'Daily Cycle',
  确定删除所选规则: 'Are you sure you want to delete the selected rule?',
  新建屏蔽规则: 'Create Shielding',
  请输入规则名称: 'Please enter the rule name',
  请输入描述: 'Please enter the description',
  编辑屏蔽规则: 'Edit Shielding Rule',
  屏蔽类型: 'Shielding Type',
  '输入查询值超过100个，请减少查询值个数后重试':
    'The number of query values exceeds 100. Please reduce the number of query values and try again.',
  单个资源模糊搜索: 'Single resource fuzzy search',
  '多个资源精确搜索，支持回车、空格、分号、逗号分隔符':
    'Multiple resource precise search, supported by Enter, space, semicolon, comma separator',
  请选择资源分组: 'Please select resource group',
  新建资源分组: 'Create Resource Group',
  新建资源: 'Create Resource',
  全局搜索: 'Global Search',
  实例屏蔽: 'Instance Shielding',
  屏蔽范围: 'Shielding Range',
  指定指标: 'Specified Metrics',
  指定事件: 'Specified Events',
  请选择屏蔽范围: 'Please select shielding range',
  生效时间范围: 'Effective Time Range',
  请选择生效时间范围: 'Please select effective time range',
  永久生效: 'Permanent Effective',
  '相对时间范围(每天循环)': 'Relative Time Range (Daily Cycle)',
  循环时间: 'Cycle Time',
  '请输入TagValue，默认全部生效，多个值使用,隔开':
    'Please enter TagValue, default all effective, multiple values using, separated',
  '请选择维度，默认为全部维度': 'Please select dimension, default all dimensions',
  云产品监控: 'Cloud Product',
  Prometheus监控: 'Prometheus Monitor',
  指标探索: 'Metric Explore',
  告警管理: 'Alarm Management',
  Grafana服务: 'Grafana Service',
  自动化运维: 'Automation Operations',
  触发器: 'Triggers',
  自动化场景: 'Automation Scenarios',
  执行记录: 'Execution Records',
  公共函数: 'Public Functions',
  未发送: 'Not Sent',
  回调地址: 'Callback URL',
  不满足告警通知时间范围: 'The alarm notification time range is not met',
  不满足累计告警次数: 'The accumulated alarm count is not met',
  不满足告警通知间隔: 'The alarm notification interval is not met',
  不满足维度标签: 'The dimension label is not met',
  已发出: 'Sent',
  已屏蔽: 'Shielded',
  已抑制: 'Suppressed',
  结果: 'Result',
  告警中: 'Alarming',
  通知记录: 'Notification Records',
  告警模板: 'Alarm Template',
  告警降噪: 'Alarm Denoising',
  告警抑制: 'Alarm Inhibition',
  告警静默: 'Alarm Silence',
  告警级别: 'Severity',
  '同一个规则内，标签名不允许重复': 'Within the same rule, label names must be unique',
  '等于(=)': 'Equals (=)',
  '不等于(!=)': 'Not Equals (!=)',
  '正则匹配(=~)': 'Regex Match (=~)',
  '正则不匹配(!~)': 'Regex Not Match (!~)',
  '标签值，多个值换行分割': 'Label values, split multiple values by line breaks',
  '告警级别，支持多选': 'Severity, multi-select supported',
  新建串行条件: 'Create Serial Condition',
  新建并行条件: 'Create Parallel Condition',
  规则状态: 'Rule Status',
  规则状态编辑成功: 'Rule status updated successfully',
  '请输入策略名称，支持模糊搜索': 'Please enter the policy name, support fuzzy search',
  '请输入规则名称，支持模糊搜索': 'Please enter rule name, support fuzzy search',
  停用: 'Disabled',
  '共{n}条规则': 'Total {n} Rules',
  全部启用: 'All Enable',
  全部停用: 'All Disable',
  '是否确认停用所选的告警规则？': 'Are you sure you want to disable the selected alarm rule?',
  '如果停用的告警规则正在触发告警，停用之后将收到该规则的恢复通知。':
    'If the disabled alarm rule is currently triggering an alarm, the recovery notification will be received after disabling.',
  '是否确认停用所选的告警策略？': 'Are you sure you want to disable the selected alarm policy?',
  '告警策略包括的告警规则将同时停用。':
    'The alarm rules included in the alarm policy will be disabled at the same time.',
  '如果停用的告警规则正在触发告警，停用后将收到该规则的恢复通知。':
    'If the disabled alarm rule is currently triggering an alarm, the recovery notification will be received after disabling.',
  确认停用: 'Confirm Disable',
  策略ID为空: 'Policy ID is empty',
  '是否确认删除所选的告警规则？': 'Are you sure you want to delete the selected alarm rule?',
  '如果删除的告警规则正在触发告警，删除之后将收到该规则的恢复通知。':
    'If the deleted alarm rule is currently triggering an alarm, the recovery notification will be received after deleting.',
  '告警策略仅包括一条规则，将同步删除告警策略信息。':
    'The alarm policy only includes one rule, and the alarm policy information will be synchronized after deleting.',
  '是否确认删除所选的告警策略？': 'Are you sure you want to delete the selected alarm policy?',
  '告警策略包括的告警规则将同时删除。':
    'The alarm rules included in the alarm policy will be deleted at the same time.',
  确认删除: 'Confirm Delete',
  确认: 'Confirm',
  取消: 'Cancel',
  规则表达式: 'Rule Expression',
  启停状态: 'Enable/Disable Status',
  '联系人/组': 'Contact/Group',
  通知方式: 'Notification Method',
  策略不存在: 'Policy does not exist',
  模板不存在: 'Template does not exist',
  模板详情加载成功: 'Template details loaded successfully',
  模板详情: 'Template Details',
  更新成功: 'Update Success',
  编辑告警模板: 'Edit Alarm Template',
  新建告警模板: 'Create Alarm Template',
  编辑告警策略: 'Edit Alarm Policy',
  新建告警策略: 'Create Alarm Policy',
  新建类型: 'Create Type',
  可视化编辑: 'Visual Edit',
  页面编辑: 'Page Edit',
  YAML编辑: 'YAML Edit',
  模板名称: 'Template Name',
  请输入模板名称: 'Please enter the template name',
  全部收起: 'All Collapse',
  全部展开: 'All Expand',
  系统模板: 'System Template',
  '若您在保存前，于页面编辑&YAML编辑均填写数据，最终将以YAML编辑提交内容为准':
    'If you fill in data in both page editing and YAML editing before saving, the data submitted will be based on YAML editing.',
  '单个策略内，规则名称不允许重复':
    'The rule name is not allowed to be repeated within a single policy',
  至少保留一条告警规则: 'Please keep at least one alarm rule',
  '通知对象&告警回调至少选择一项配置':
    'At least one of notification object & alarm callback must be selected',
  保存当前告警策略为模板: 'Save current alarm policy as template',
  '默认将告警策略名称设置为模板名称。保存后可前往告警模板页编辑模板名称及内容。':
    'The alarm policy name will be set as the template name by default. After saving, you can go to the alarm template page to edit the template name and content.',
  请输入告警回调: 'Please enter the alarm callback',
  告警回调不能重复: 'The alarm callback cannot be repeated',
  告警回调不支持英文逗号: 'The alarm callback does not support English comma',
  新建回调: 'Create Callback',
  '填写公网可访问到的URL作为回调接口地址,例如:https://console.ksyun.com:8080/callback':
    'Please enter the URL of the callback interface address, such as: https://console.ksyun.com:8080/callback',
  PromQL数据预览: 'PromQL Data Preview',
  关闭: 'Off',
  查询时间: 'Query Time',
  开始时间与结束时间最大30分钟: 'The maximum interval between start and end time is 30 minutes',
  '请注意：共{n}条数据，默认展示20条序列。':
    'Please note: there are {n} data rows in total, and 20 series are displayed by default.',
  名称: 'Name',
  最大值: 'Max',
  最小值: 'Min',
  平均值: 'Avg',
  '同一个规则内，label-name不允许重复': 'Within the same rule, label-name must be unique',
  '同一个规则内，annotation-name不允许重复': 'Within the same rule, annotation-name must be unique',
  持续时间: 'Duration',
  预览: 'Preview',
  '触发规则的最小持续时间。如：若设置为0，则满足规则时立刻触发告警。若设置为1分钟，则持续满足规则1分钟后触发告警，1分钟内视为正常波动不触发告警。':
    'The minimum duration for which the trigger condition must persist. For example: ' +
    'if set to 0, an alert is triggered immediately once the condition is met. ' +
    'If set to 1 minute, the condition must persist for 1 minute before triggering, ' +
    'and fluctuations within 1 minute are treated as normal.',
  分钟: 'Minute',
  小时: 'Hour',
  '告警等级({name})': 'Alert Level ({name})',
  'critical: 需要立即处理的告警;': 'critical: alert requires immediate handling;',
  'error: 产生错误，可能需要处理;': 'error: an error occurred and may need handling;',
  'warning: 存在风险;': 'warning: potential risk exists;',
  注解: 'Annotations',
  告警摘要: 'Alert Summary',
  告警内容: 'Alert Description',
  规则启停: 'Rule Status',
  当下面指标满足: 'When the following metric conditions are met',
  '且：所有规则都满足时触发告警': 'AND: trigger alert when all rules are met',
  '或：任意一个规则满足时触发告警': 'OR: trigger alert when any rule is met',
  且: 'AND',
  或: 'OR',
  条件且持续: 'Condition persists for',
  '0表示满足条件就触发': '0 means alert is triggered as soon as conditions are met',
  '分钟时，将触发': 'minutes, then trigger',
  级别告警: 'severity alert',
  序号: 'No.',
  统计周期: 'Aggregation Period',
  统计方法: 'Aggregation Method',
  大小: 'Comparison',
  阈值: 'Threshold',
  持续周期数: 'Consecutive Periods',
  告警间隔: 'Alert Interval',
  最大告警次数: 'Max Alert Count',
  新建指标: 'Create Metric',
  新建规则: 'Create Rule',
  请选择产品类型: 'Please select product type',
  标签名: 'Label Name',
  操作符: 'Operator',
  标签值: 'Label Value',
  新建维度: 'Create Dimension',
  该指标下无维度: 'No dimensions under this metric',
  请先选择指标: 'Please select a metric first',
  '策略 / 规则': 'Policy / Rule',
  关联资源: 'Associated Resource',
  告警状态: 'Alert Status',
  删除成功: 'Deleted successfully',
  新建静默规则: 'Create Silence Rule',
  编辑静默规则: 'Edit Silence Rule',
  静默状态: 'Silence Status',
  静默规则名称: 'Silence Rule Name',
  请输入静默规则名称: 'Please enter silence rule name',
  静默规则状态: 'Silence Rule Status',
  待生效: 'Pending Effective',
  已过期: 'Expired',
  静默时间: 'Silence Time',
  描述: 'Description',
  编辑时间: 'Edit Time',
  编辑: 'Edit',
  编辑成功: 'Saved successfully',
  编辑联系人: 'Edit Contact',
  编辑联系组: 'Edit Contact Group',
  新建联系人: 'Create Contact',
  新建联系组: 'Create Contact Group',
  编辑条件: 'Edit Condition',
  '新建/编辑警报': 'Create/Edit Alarm',
  '新建或编辑数据成功。': 'Data created or updated successfully.',
  '发出的请求有错误，服务器没有进行新建或编辑数据的操作。':
    'The request was invalid. The server did not create or update any data.',
  '当新建一个对象时，发生一个验证错误。':
    'A validation error occurred while creating the object.',
  复制: 'Copy',
  '是否确认删除【{name}】静默规则？': 'Are you sure to delete silence rule [{name}]?',
  匹配规则: 'Match Rules',
  开始时间与结束时间最大30天: 'The maximum interval between start and end time is 30 days',
  新建抑制规则: 'Create Inhibition Rule',
  编辑抑制规则: 'Edit Inhibition Rule',
  抑制规则名称: 'Inhibition Rule Name',
  匹配条件: 'Match Conditions',
  '是否确认删除【{name}】抑制规则？': 'Are you sure to delete inhibition rule [{name}]?',
  源告警: 'Source Alert',
  源告警的标签匹配规则: 'Label matching rules for source alerts',
  目标告警: 'Target Alert',
  目标告警的标签匹配规则: 'Label matching rules for target alerts',
  用于匹配源告警和目标告警的一组标签名:
    'A set of label names used to match source and target alerts',
  '请输入匹配条件，多个条件换行分割':
    'Please enter match conditions, split multiple conditions by line breaks',
  静默: 'Silenced',
  抑制: 'Inhibited',
  静默且抑制: 'Silenced and Inhibited',
  已恢复: 'Recovered',
  联系人: 'Contact',
  回调: 'Callback',
  通知类型: 'Notification Type',
  模板类型: 'Template Type',
  未知类型: 'Unknown Type',
  '近0.5小时': 'Last 0.5 Hours',
  近1小时: 'Last 1 Hour',
  近1天: 'Last 1 Day',
  近3天: 'Last 3 Days',
  近1周: 'Last 1 Week',
  近30天: 'Last 30 Days',
  '告警等级（severity）': 'Alert Level (severity)',
  选择实例: 'Select Instance',
  请选择实例: 'Please select instance',
  '请先新建{name}下Prometheus实例。': 'Please create a Prometheus instance in {name} first.',
  开通Prometheus实例: 'Enable Prometheus Instance',
  '请先开通grafana服务。': 'Please enable Grafana service first.',
  点击开通Grafana服务: 'Click to enable Grafana service',
  新建Prometheus实例: 'Create Prometheus Instance',
  开通金山云Prometheus监控服务: 'Enable Kingsoft Cloud Prometheus Monitoring Service',
  '开通后将为您在当前region下新建Prometheus实例。是否开通？':
    'After enabling, a Prometheus instance will be created in the current region. Continue?',
  开通实例: 'Enable Instance',
  实例信息: 'Instance Information',
  预聚合: 'Pre-aggregation',
  新建预聚合: 'Create Pre-aggregation',
  预聚合规则名称: 'Pre-aggregation Rule Name',
  '请输入预聚合规则名称，支持模糊搜索':
    'Please enter pre-aggregation rule name, fuzzy search is supported',
  规则组个数: 'Rule Group Count',
  '是否确认停用【{name}】的预聚合规则？': 'Are you sure to disable pre-aggregation rule [{name}]?',
  '是否确认删除【{name}】的预聚合规则？': 'Are you sure to delete pre-aggregation rule [{name}]?',
  预聚合规则: 'Pre-aggregation Rule',
  编辑预聚合规则: 'Edit Pre-aggregation Rule',
  新建预聚合规则: 'Create Pre-aggregation Rule',
  操作成功: 'Operation Succeeded',
  基础信息: 'Basic Information',
  服务地址: 'Service Endpoints',
  Federate地址: 'Federate Endpoint',
  网络: 'Network',
  'Remote Write地址': 'Remote Write Endpoint',
  'HTTP API地址': 'HTTP API Endpoint',
  获取Token失败: 'Failed to get token',
  发送时间: 'Send Time',
  恢复: 'Recovered',
  类型: 'Type',
  自定义模板: 'Custom Template',
  是否确认删除告警模板: 'Are you sure you want to delete the alarm template',
  '紧急（Critical）：邮件、短信、电话均会通知。':
    'Critical: Email, SMS, and phone notifications will be sent.',
  '严重（Error）：邮件、短信通知。': 'Error: Email and SMS notifications will be sent.',
  '警告（Warning）：仅邮件通知。': 'Warning: Only email notifications will be sent.',
  通知对象: 'Notification',
  请选择: 'Please select',
  自定义: 'Custom',
  飞书: 'Feishu',
  钉钉: 'Dingtalk',
  企业微信: 'Wecom',
  WPS协作: 'WPS',
  initYaml:
    // eslint-disable-next-line max-len
    'rules:\n  - alert: HighRequestLatency #Alarm Name, required  \n    expr: job:request_latency_seconds:mean5m{job="myjob"} > 0.5  #Rule, required\n    for: 10m #Duration, optional. Unit: m(minutes) or h(hours)\n    labels:\n      severity: critical #Severity, required. Enum: critical/warning/error\n      version: 1.0 # User-defined label example\n    annotations:\n      summary: High request latency #Alert summary, required\n      description: High request latency #Alert description, required\n      region: beijing # User-defined annotation example',
  确认停用所选联系人: 'Are you sure you want to disable the selected contact?',
  确认启用所选联系人: 'Are you sure you want to enable the selected contact?',
  确认删除所选联系人: 'Are you sure you want to delete the selected contact?',
  值班管理: 'Schedule Management',
  确认删除所选的值班表吗: 'Are you sure you want to delete the selected schedule?',
  新建值班表: 'Create Schedule',
  编辑值班表: 'Edit Schedule',
  值班表名称: 'Schedule Name',
  换班时间: 'Change Time',
  值班周期: 'Schedule Period',
  按天: 'Day',
  按周: 'Week',
  当前值班人: 'Current Duty Person',
  值班班次: 'Duty Shift',
  值班配置: 'Duty Configuration',
  结束时间不能超过开始时间30天: 'The end time cannot be more than 30 days after the start time',
  '近{n}周': 'Last {n} Weeks',
  周日: 'Sunday',
  周一: 'Monday',
  周二: 'Tuesday',
  周三: 'Wednesday',
  周四: 'Thursday',
  周五: 'Friday',
  周六: 'Saturday',
  值班表名: 'Schedule Name',
  请输入值班表名: 'Please enter schedule name',
  请选择结束时间: 'Please select end time',
  请选择开始时间: 'Please select start time',
  审批撤回成功: 'Approval withdrawn successfully',
  审批驳回成功: 'Approval rejected successfully',
  审批通过成功: 'Approval approved successfully',
  审批详情: 'Approval details',
  驳回: 'Reject',
  通过: 'Approve',
  根据主机名查询主机所在集群: 'Look up the cluster a host belongs to by hostname',
  kas启动训练任务函数: 'KAS function to start a training job',
  '交换机主机名/管理IP': 'Switch hostname / management IP',
  命令编号: 'Command ID',
  查看原始命令: 'View raw command',
  '临时改为公开状态，不限用户可调用':
    'Temporarily set to public; callable by users without restriction',
  '测试递归-全排列': 'Test recursion — all permutations',
  '测试递归-求和': 'Test recursion — sum',
  看看公共函数新建时的参数: 'Inspect parameters when creating a public function',
  测试函数影响范围: 'Test function impact scope',
  这是一个备注: 'This is a remark',
  无: 'None',
  测试codemirror组件的公共函数: 'Test public function for the Codemirror component',
  测试: 'Test',
  聚合标识: 'Aggregation key',
  '数据业务类型，如:alarm': 'Data business type, e.g. alarm',
  聚合的数据: 'Data to aggregate',
  '聚合周期类型，可选：fixed固定周期、postpone顺延': 'Aggregation interval type: fixed or postpone',
  '聚合周期，单位秒': 'Aggregation interval in seconds',
  '最大数量（sum相关类型有效）': 'Maximum count (for sum-related types)',
  聚合数据: 'Aggregated data',
  告警认领编号: 'Alarm claim ID',
  工号: 'Employee ID',
  备注信息: 'Remarks',
  秒: 'Second',
  认领告警: 'Claim alarm',
  认领并完成告警: 'Claim and complete alarm',
  获取告警配置: 'Get alarm configuration',
  员工工号: 'Employee ID',
  完成告警: 'Complete alarm',
  '123 已知晓数据处理脚本中可能存在的高危操作命令':
    '123 — acknowledged that data-processing scripts may contain high-risk commands',
  上一步: 'Previous step',
  事件内容: 'Event content',
  事件名称: 'Event name',
  事件状态: 'Event status',
  事件等级: 'Event severity',
  事件类型: 'Event type',
  事件聚合: 'Event aggregation',
  产品类型: 'Product type',
  人工介入: 'Manual intervention',
  人工发起: 'Manual initiation',
  会签: 'Countersign',
  例子: 'Example',
  全部正确: 'All correct',
  函数名称: 'Function name',
  创建时间: 'Created at',
  创建者: 'Creator',
  删除: 'Delete',
  前置节点输入: 'Upstream node input',
  前置节点输出: 'Upstream node output',
  加密: 'Encrypt',
  不加密: 'Not encrypt',
  参数: 'Parameters',
  参数名: 'Parameter name',
  发布时间: 'Published at',
  变量值: 'Variable value',
  变量名: 'Variable name',
  否: 'No',
  固定值: 'Fixed value',
  场景的测试记录: 'Scene test records',
  基本信息: 'Basic Info',
  基础流程图: 'Basic flowchart',
  备注: 'Remarks',
  子场景: 'Sub-scene',
  存在误判: 'False positive',
  定时任务: 'Scheduled task',
  定时器: 'Timer',
  实例名称: 'Instance name',
  审批中: 'Pending approval',
  已停用: 'Disabled',
  已新建: 'Added',
  已发布场景的执行记录: 'Execution records of published scenes',
  开始: 'Start',
  必填: 'Required',
  执行结束: 'Execution finished',
  操作: 'Operation',
  操作人: 'Operator',
  数据处理: 'Data processing',
  新建场景: 'Create Scene',
  是: 'Yes',
  未评价: 'Not rated',
  机房: 'Data center',
  查看: 'View',
  流程图: 'Flowchart',
  流程输入: 'Flow input',
  '流程输出将作为流程流转完毕的结果，常用于结果的通知内容和作为子节点时的节点输出。':
    'Flow output is the final result of the flow, often used in notifications and as child node output',
  版本: 'Version',
  版本说明: 'Version description',
  特殊变量: 'Special variables',
  状态: 'Status',
  示例: 'Example',
  系统预置: 'System preset',
  终止: 'Terminate',
  结束: 'End',
  聚合Key: 'Aggregation key',
  聚合长度: 'Aggregation length',
  脚本内容: 'Script content',
  触发开始: 'Trigger start',
  '触发结束（失败）': 'Trigger end (failed)',
  '触发结束（成功）': 'Trigger end (success)',
  详细信息: 'Details',
  语言: 'Language',
  语言类型: 'Language type',
  '输入参数收集到的值，可以在功能按钮中进行查看和编辑处理。':
    'Collected input values can be viewed and edited from the action buttons',
  '输入参数收集到的值，可以在数据脚本中以普通变量的方式使用。':
    'Collected input values can be used as ordinary variables in the data script',
  进行中: 'In progress',
  遗漏: 'Omitted',
  错误: 'Error',
  预发布: 'Pre-release',
  验证: 'Validate',
  '验证节点的输入参数，可作为路由选择的判定。':
    'Validate node input parameters for routing decisions',
  默认值: 'Default value',
  催办: 'Remind',
  催办成功: 'Reminder sent successfully',
  '当前节点：': 'Current node:',
  '当前处理人：': 'Current assignee(s):',
  操作日志: 'Operation log',
  保存成功: 'Saved successfully',
  新建成功: 'Created successfully',
  暂存: 'Save draft',
  '正式发布前会先走审批流程进行审批，审批通过后自动发布。':
    'Official release goes through approval first; after approval it is published automatically.',
  发布: 'Publish',
  '存在审批中的版本，暂不允许进行编辑操作。如确实需要，请先撤回审批。':
    'A version is under approval; editing is not allowed. Withdraw the approval first if you must edit.',
  触发源: 'Trigger source',
  触发规则: 'Trigger rule',
  '或（Or）': 'Or',
  查看历史事件: 'View event history',
  '示例：[0 8,15 * * 1-5]每周一到周五的8:00和15:00执行一次。':
    'Example: [0 8,15 * * 1-5] runs at 8:00 and 15:00 every Monday through Friday.',
  格式不正确: 'Invalid format',
  分: 'Min',
  时: 'Hr',
  日: 'Day',
  月: 'Mo',
  周: 'Wk',
  触发动作: 'Trigger action',
  场景名称: 'Scene name',
  '此场景还未发布，关联后本触发器只可暂存':
    'This scene is not published yet; after linking, this trigger can only be saved as draft.',
  刷新: 'Refresh',
  '触发场景所需参数：': 'Parameters required for the trigger scene:',
  '。请在下方数据处理中，使用g_print函数输出所需参数。':
    ' Use g_print in data processing below to output the required parameters.',
  通知订阅: 'Notification subscription',
  通知联系人: 'Notification contacts',
  '通知联系人&通知回调至少选择一项配置':
    'Configure at least one of notification contacts or notification callbacks',
  通知回调: 'Notification callbacks',
  熔断机制: 'Circuit breaker',
  滑动窗口: 'Sliding window',
  '最多触发填0次时，滑动窗口只能填0': 'When max triggers is 0, the sliding window must be 0',
  '秒内, 最多触发': ' s, at most ',
  '滑动窗口填0时，最多触发只能填0': 'When the sliding window is 0, max triggers must be 0',
  '次。': ' time(s).',
  '滑动窗口期内本触发器触发动作超过设置次数时将开启熔断。任意值为0时，不会触发熔断机制。':
    'If this trigger fires more than allowed within the window, the circuit breaker opens. If any value is 0, the breaker is off.',
  版本信息: 'Version information',
  发布成功: 'Published successfully',
  新版本号: 'New version number',
  新的版本号需要大于当前版本号: 'The new version must be greater than the current version',
  请填写完整版本号: 'Please enter a complete version number',
  请填写版本说明: 'Please enter version notes',
  本次更新的重点内容说明: 'Summary of changes in this update',
  次: 'times',
  '触发记录/次': 'Trigger records',
  启用: 'Enable',
  编号: 'No.',
  动作类型: 'Action type',
  开始时间: 'Start Time',
  结束时间: 'End Time',
  执行: 'Execute',
  执行成功: 'Succeeded',
  执行中: 'Running',
  触发失败: 'Trigger failed',
  执行失败: 'Execution failed',
  点击查看详情: 'Click to view details',
  执行结果搜索: 'Search by execution result',
  详情: 'Details',
  自定义表格显示项: 'Custom table columns',
  数据源: 'Data source',
  执行数据: 'Execution data',
  执行结果: 'Execution result',
  '请输入维度值，默认全部生效，多个值请使用英文,分割':
    'Enter dimension values; leave default for all. Separate multiple values with commas (English).',
  '并且（Add）': 'And (Add)',
  请在此处输入告警聚合key: 'Enter the alarm aggregation key here',
  items必须为数组: '"items" must be an array',
  'JSON 格式错误': 'Invalid JSON format',
  提交测试: 'Submit test',
  '提交测试后，系统将按照您设定的操作进行执行，请严格确认是否会对线上业务产生影响，谨慎调试。':
    'After submission the system runs as configured. Confirm carefully that this will not harm production.',
  '输入参数：': 'Input parameters:',
  '请输入原始告警JSON数据，可从[触发规则->查看历史事件]面板中复制告警数据。':
    'Enter raw alarm JSON (you can copy alarm data from Trigger rule → View event history).',
  测试结果: 'Test result:',
  历史事件: 'Event history',
  暂无结果: 'No results',
  关联实例: 'Associated instance',
  所属区域: 'Region',
  停用成功: 'Disabled successfully',
  启用成功: 'Enabled successfully',
  请填写操作备注: 'Please enter an operation note',
  '将删除规则数据，且不可恢复！删除前确保触发器已被停用，且没有正在审批中的记录':
    'Rule data will be deleted and cannot be recovered. Disable the trigger and ensure no record is pending approval.',
  请输入触发器名称: 'Enter the trigger name',
  进行删除确认: 'to confirm deletion',
  操作类型: 'Operation type',
  时间: 'Time',
  请在数据转换中将原始参数转换为目标动作所需参数:
    'Please convert the original parameters to the target action parameters in the data conversion',
  节点名称: 'Node name',
  节点类型: 'Node type',
  流程输出: 'Flow output',
  输入参数: 'Input parameters',
  输出参数: 'Output parameters',
  审批联系人: 'Approval contacts',
  审批回调: 'Approval callbacks',
  请选择前置节点Key: 'Please select the key of the upstream node',
  请选择前置节点: 'Please select the upstream node',
  请输入值: 'Please enter the value',
  请输入Key: 'Please enter the key',
  节点配置: 'Node configuration',
  路由配置: 'Routing configuration',
  判定条件: 'Judgment conditions',
  '子场景的输出参数为其所有结束节点输出的并集，实际运行中可能会有空值的情况':
    'The output parameters of the sub-scene are the union of the outputs of all end nodes, and there may be empty values in actual operation.',
  延迟时长: 'Delay duration',
  配置执行表单: 'Configure execution form',
  '正式发布前会先走审批流程进行审批，审批通过后自动发布':
    'Official release goes through approval first; after approval it is published automatically.',
  系统场景不允许编辑: 'System scene cannot be edited',
  '已复制到粘贴板，请点击【新建场景】按钮去导入':
    'Copied to clipboard. Click [Create Scene] to import.',
  退出编辑: 'Exit editing',
  当前版本为: 'Current version is',
  发起时间: 'Start time',
  耗时: 'Duration',
  是否正确: 'Is correct',
  时间运维执行记录: 'Time operation execution record',
  仅查看测试记录: 'Only view test records',
  来源: 'Source',
  场景内容: 'Scene content',
  节点详情: 'Node details',
  日志详情: 'Log details',
  操作备注: 'Operation remarks',
  确定删除: 'Confirm deletion',
  用户: 'User',
  操作时间: 'Operation time',
  标题: 'Title',
  日志: 'Log',
  评价: 'Evaluation',
  评价备注: 'Evaluation remarks',
  定位结果: 'Evaluation result',
  正确结果: 'Success result',
  遗漏结果: 'Missed result',
  '上述结果哪些项是定位正确的结果？': 'Which items are the correct results for the above results?',
  '上述哪些项是真正结果，但系统没有定位到？':
    'Which items are the correct results, but the system did not locate?',
  '本次定位结果是否全部正确？': 'Is the current positioning result all correct?',
  查看详情: 'View details',
  按函数名称搜索: 'Search by function name',
  列表展示形式: 'List view',
  文档展示形式: 'Document view',
  新建函数: 'Create Function',
  删除失败: 'Delete failed',
  请输入正确的函数名称进行确认: 'Please enter the correct function name to confirm',
  '该公共函数已应用，不可删除，需要解除关联使用后，再删除':
    'The public function has been applied, cannot be deleted, need to解除关联使用后，再删除',
  编辑函数: 'Edit function',
  变量: 'Variables',
  请输入函数名称: 'Please enter the function name',
  新建变量: 'Create Variable',
  请输入备注: 'Please enter the remarks',
  '常用于加密数据、核心配置的变量定义': 'Variables used for encrypting data and core configuration',
  影响范围: 'Impact scope',
  暂无影响范围数据: 'No impact scope data',
  '将删除此公共函数数据,且不可恢复!':
    'The public function data will be deleted, and cannot be recovered!',
  无参数: 'No parameters',
  '分隔线之上的区域为模板区域，不允许编辑':
    'The area above the separator is a template area, not allowed to edit',
  确认发布: 'Confirm publish',
  无输出: 'No output',
  新建事件告警策略: 'Create Event Alarm Policy',
  取消收藏成功: 'Unfavorites successfully',
  收藏成功: 'Favorites successfully',
  云产品收藏个数超过上限20个: 'The number of cloud product favorites exceeds the upper limit of 20',
  输入面板名称: 'Enter panel name',
  输入实例ID: 'Enter instance ID',
  开通金山云共享版Grafana: 'Enable Kingsoft Cloud Shared Grafana',
  '开通失败，请创建工单或联系售后人员':
    'Failed to enable, please create a ticket or contact after-sales personnel',
  当前所有Region下均未发现Prometheus实例: 'No Prometheus instances found in all regions',
  '当前所有Region下均未发现Prometheus实例，请先开通Prometheus实例':
    'No Prometheus instances found in all regions, please enable Prometheus instance first',
  确认开通: 'Confirm enable?',
  '将为您开通Grafana实例。是否开通': 'A Grafana instance will be enabled for you. Continue?',
  运行状态: 'Running status',
  版本号: 'Version number',
  公网地址: 'Public address',
  '金山云共享版Grafana实例为您提供多租户共享的监控仪表盘，支持基础数据可视化功能。':
    'Kingsoft Cloud Shared Grafana instance provides a shared monitoring dashboard for multi-tenant users, supporting basic data visualization functions.',
  数据存储时长: 'Data storage duration',
  天: 'day',
  公网: 'Public',
  内网: 'Private',
  开: 'Open',
  关: 'Close',
  云产品Dashboard: 'Cloud product Dashboard',
  新建自定义Dashboard: 'Create Custom Dashboard',
  资源列表: 'Instance list',
  IB网络拓扑: 'IB network topology',
  ROCE网络拓扑: 'ROCE network topology',
  确认删除以下警报策略: 'Confirm to delete the following alarm policy?',
  小于: 'Less than',
  '当前资源监控项维度最大支持勾选{max}个':
    'The current resource monitoring item dimension supports a maximum of {max} selections',
  资源未匹配维度: 'Resource unmatched dimension',
  资源实例存在未匹配的纬度信息: 'Resource instance exists unmatched dimension information',
  '确定复制所选图表吗？复制图表默认资源为空，需手动新建资源':
    'Copy the selected chart? The copy has no resources by default; add them manually.',
  该监控视图为实例聚合视图: 'The monitoring view is an instance aggregation view',
  时间点: 'Time point',
  以下数据为空: 'The following data is empty',
  确认删除图表吗: 'Confirm to delete the chart?',
  '仅监控项含维度时可选该项。若选择聚合方式，按实例取维度值中的最大值/最小值/平均值/求和值展示。若选择不聚合，展示各维度数据。':
    // eslint-disable-next-line max-len
    'This option is only available when the monitoring item contains dimensions. If you select the aggregation method, the maximum/minimum/average/sum values of the dimension values of the instance are displayed. If you select not to aggregate, the data of each dimension is displayed.',
  '仅选择2个及以上实例时可选该项。若选择聚合方式，取所选多个实例中的最大值/最小值/平均值/求和值展示。若选择不聚合，展示各实例数据。':
    // eslint-disable-next-line max-len
    'This option is only available when two or more instances are selected. If you select the aggregation method, the maximum/minimum/average/sum values of the selected multiple instances are displayed. If you select not to aggregate, the data of each instance is displayed.',
  '对每个周期内数据进行分组聚合展示。':
    // eslint-disable-next-line max-len
    'The data of each period is grouped and aggregated for display.',
  '请先选择实例，再选择维度，维度只有一个时，默认选择，维度存在多个时，可选择多个维度进行展示，不选时默认选择全部维度。':
    // eslint-disable-next-line max-len
    'Please select the instance first, then select the dimension. When there is only one dimension, it is selected by default. When there are multiple dimensions, multiple dimensions can be selected for display. If no dimension is selected, all dimensions are selected by default.',
  '请选择产品类型和监控项，定义展示在图表中的数据':
    'Please select the product type and monitoring item to define the data displayed in the chart',
  '该计数为NAT时随机选择端口可能产生的冲突计数，仅当统计周期内，大量冲突计数产生，表明NAT端口资源紧张，建议阈值调整为每分钟200':
    // eslint-disable-next-line max-len
    'The count is the number of port conflicts that may occur when randomly selecting ports for NAT. Only when a large number of conflicts occur within the statistical period, it indicates that the NAT port resource is紧张，建议阈值调整为每分钟200',
  布局: 'Layout',
  角色布局: 'Role layout',
  分散布局: 'Disperse layout',
  当前为: 'Current is',
  前的数据: 'previous data',
  最新数据请: 'Latest data please',
  获取: 'Get',
  操作状态: 'Operation status',
  指标信息: 'Indicator information',
  接口信息: 'Interface information',
  厂商: 'Manufacturer',
  CPU利用率: 'CPU utilization',
  内存利用率: 'Memory utilization',
  MAC利用率: 'MAC utilization',
  ARP利用率: 'ARP utilization',
  ND利用率: 'ND utilization',
  FIBv4利用率: 'FIBv4 utilization',
  FIBv6利用率: 'FIBv6 utilization',
  设备信息: 'Device information',
  设备详情: 'Device details',
  交换机: 'Switch',
  防火墙: 'Firewall',
  路由器: 'Router',
  未管理: 'Unmanaged',
  正常: 'Normal',
  离线: 'Offline',
  未知: 'Unknown',
  SNMP不可达: 'SNMP unreachable',
  端口信息: 'Port information',
  总告警数: 'Total alarms',
  温度: 'Temperature',
  SW版本: 'SW version',
  FW版本: 'FW version',
  设备类型: 'Device type',
  所属模型: '所属模型',
  严重等级: 'Severity level',
  新建参数: 'New parameter',
  分析设置: 'Analysis settings',
  链路分析: 'Link analysis',
  分层布局: 'Layer layout',
  告警设置: 'Alarm settings',
  开启: 'Open',
  告警联系人: 'Alarm contacts',
  告警回调: 'Alarm callbacks',
  告警名称: 'Alarm name',
  告警等级: 'Alarm level',
  当前搜索内容: 'Current search content',
  姓名: 'Name',
  电话: 'Phone',
  维度设置: 'Dimension settings',
  请输入维度: 'Please enter the dimension',
  '请输入 JSON 数据...': 'Please enter JSON data...',
  'JSON必须是对象或数组，不能是原始值（数字、字符串、布尔值等）':
    'JSON must be an object or array, not a primitive value (number, string, boolean, etc.)',
  'JSON 格式化成功': 'JSON formatting successful',
  'JSON 格式化失败': 'JSON formatting failed',
  格式化: 'Format',
  链路详情: 'Link details',
  链路信息: 'Link information',
  源信息: 'Source information',
  目标信息: 'Destination information',
  请选择维度值: 'Please select the dimension value',
  请选择维度: 'Please select the dimension',
  设备: 'Device',
  维度名: 'Dimension name',

  // AI 可观测
  AI可观测: 'AI Observability',
  Python接入: 'Python Integration',
  服务接入: 'Service Integration',
  监控系统: 'Monitoring System',
  数据采集方式: 'Data Collection Method',
  OpenTelemetry: 'OpenTelemetry',
  Longfuse: 'Longfuse',
  SDK: 'SDK',
  服务总览: 'Service Overview',
  概览: 'Overview',
  服务数: 'Services',
  会话数: 'Sessions',
  消息数: 'Messages',
  答复率: 'Reply rate',
  Token消耗数: 'Token Consumption',
  调用数: 'Invocations',
  错误数: 'Errors',
  错误率: 'Error Rate',
  会话分析: 'Session Analysis',
  Trace分析: 'Trace Analysis',
  接入中心: 'Access Center',
  总览: 'Overview',
  服务列表: 'Service List',
  '请输入服务名称，支持模糊搜索': 'Please enter service name for fuzzy search',
  服务名称: 'Service Name',
  服务语言: 'Service Language',
  采集来源: 'Collection Source',
  服务类型: 'Service Type',
  服务状态: 'Service Status',
  运行中: 'Running',
  不活跃: 'Inactive',
  区域标识: 'Region',
  服务详情: 'Service Details',
  运行时总览: 'Runtime Overview',
  会话ID: 'Session ID',
  所属服务: 'Service',
  输入Token: 'Input Token',
  输出Token: 'Output Token',
  调用链数量: 'Trace Count',
  会话开始时间: 'Session Start Time',
  会话结束时间: 'Session End Time',
  '会话 ID': 'Session ID',
  调用链数: 'Trace Count',
  LLM调用次数: 'LLM Call Count',
  错误次数: 'Error Count',
  链路数量: 'Span Count',
  Token使用情况: 'Token Usage',
  缓存读取Token: 'Cache Read Token',
  暂无链路数据: 'No trace data',
  '第{x}次调用': 'Call #{x}',
  调用链ID: 'Trace ID',
  聚合方式: 'Aggregation',
  自动刷新: 'Auto Refresh',
  自动刷新设置成功: 'Auto refresh updated',
  '5秒': '5s',
  '10秒': '10s',
  '30秒': '30s',
  '1分钟': '1 min',
  '5分钟': '5 min',
  包含: 'Contains',
  不包含: 'Not Contains',
  请输入: 'Please input',
  请输入起始值: 'Please input start value',
  请输入结束值: 'Please input end value',
  原始日志: 'Raw Logs',
  '暂无 Span 数据': 'No span data',
  单链路详情: 'Trace Details',
  列表: 'List',
  拓扑: 'Topology',
  大模型组件标签: 'LLM Component Tags',
  输入Span关键字: 'Search span keyword',
  查看异常Span: 'Error Spans',
  '暂无 Span': 'No span',
  放大: 'Zoom In',
  缩小: 'Zoom Out',
  适应画布: 'Fit to Canvas',
  'Span 类型': 'Span Type',
  状态码: 'Status Code',
  下游服务: 'Downstream Service',
  主机名: 'Hostname',
  属性: 'Attributes',
  暂无属性: 'No attributes',
  'Token 消耗': 'Token Usage',
  '总消耗 Token': 'Total Tokens',
  'Input 缓存 Token': 'Input Cached Tokens',
  起始时间: 'Start Time',
  服务名: 'Service Name',
  展开: 'Expand',
  列表筛选: 'List Filters',
  属性名: 'Attribute Name',
  属性值: 'Attribute Value',
  删除条件: 'Remove Condition',
  'Span 属性筛选': 'Span Attribute Filters',
  新建条件: 'Create Condition',
  新建: 'Create',
  批量新建: 'Batch Create',
  新建产品线: 'Create Product Line',
  新建实例: 'Create Instance',
  新建事件: 'Create Event',
  新建警报: 'Create Alarm',
  新建绘图: 'Create Chart',
  批量新建绘图: 'Batch Create Charts',
  新建监控视图: 'Create Monitoring View',
  新建监控项: 'Create Monitoring Item',
  编辑监控视图: 'Edit Monitoring View',
  是否新建至绘图: 'Add to chart',
  未新建: 'Not added',
  确认新建: 'Confirm create',
  '确认新建？': 'Confirm create?',
  '指标已存在相同警报，确定要继续新建吗？':
    'The metric already has the same alarm. Continue to create?',
  '指标已新建警报的指标，请您删除相应的警报':
    'Metrics with existing alarms: {msg}. Please delete the corresponding alarms first.',
  '单个视图最多可新建1000条监控数据':
    'A single view can contain up to 1000 monitoring data entries',
  监控视图最多新建1000条数据: 'A monitoring view can contain up to 1000 data entries',
  自选实例单次最多新建500个资源: 'You can add up to 500 resources at a time for custom instances',
  单个产品线最多可新建10条规则: 'A product line can have up to 10 rules',
  '操作新建，点击确认后生效': 'Create operation takes effect after you click Confirm',
  请勿新建相同维度: 'Do not create duplicate dimensions',
  '将为您在当前region下新建Prometheus实例。是否新建？':
    'A Prometheus instance will be created in the current region. Continue?',
  Span名称: 'Span Name',
  模型名称: 'Model Name',
  Span类型: 'Span Type',
  'AI Span类型': 'AI Span Type',
  暂无数据: 'No data',
  'Root Span列表': 'Root Span List',
  Span列表: 'Span List',
  接入: 'Integration',
  接入协议类型: 'Protocol Type',
  接入指南: 'Integration Guide',
  '一、安装OpenTelemetry SDK': '1. Install OpenTelemetry SDK',
  '通过pip安装OpenTelemetry SDK，要求python版本大于等于3.9':
    'Install OpenTelemetry SDK via pip, Python >= 3.9 is required',
  '二、参考下面的代码示例，正确设置http header和otlp endpoint':
    '2. Refer to the sample code below and set http header and otlp endpoint correctly',
  在exporter的: 'In exporter',
  中正确设置: 'set correctly',
  格式如下: 'format as follows',
  '如果通过http协议上报，将otlp的endpoint设置为': 'If reporting via HTTP, set the OTLP endpoint to',
  '如果通过grpc协议上报，将otlp的endpoint设置为': 'If reporting via gRPC, set the OTLP endpoint to',
  '一、安装Langfuse SDK': '1. Install Langfuse SDK',
  '通过pip安装Langfuse SDK，要求python版本大于等于3.9':
    'Install Langfuse SDK via pip, Python >= 3.9 is required',
  '二、参考下面的代码示例，正确设置public key、secret key和host':
    '2. Refer to the sample code below and set public key, secret key, and host correctly',
  正确设置: 'set correctly',
  设置为: 'set to',
  '三、在云监控中观测是否有trace上报': '3. Verify trace reporting in cloud monitoring',
  '一、安装OpenLLMetry SDK': '1. Install OpenLLMetry SDK',
  '通过pip安装OpenLLMetry SDK，要求python版本大于等于3.9':
    'Install OpenLLMetry SDK via pip, Python >= 3.9 is required',
  '二、安装OpenLLMetry SDK': '2. Install OpenLLMetry SDK',
  '参考下面的代码示例，正确设置http header和otlp endpoint':
    'Refer to the sample code below and set http header and otlp endpoint correctly',
  '在exporter的http header中正确设置app-key，格式如下：':
    'Set app-key in exporter http header correctly, format as follows:',
  收起筛选: 'Collapse filters',
  展开筛选: 'Expand filters',
  Trace详情: 'Trace Details'
}

// 替换之前配置错误的key
export const localDictCn = {
  '告警服务升级了，查看如何': '告警服务升级了，查看如何',
  '共{n}个视图': '共{n}个视图',
  '在{n}内': '在{n}内',
  '间隔{n}告警一次': '间隔{n}告警一次',
  '共{x}个资源告警数': '共{x}个资源告警数',
  '共{n}条': '共{n}条',
  '共{n}条规则': '共{n}条规则',
  '请注意：共{n}条数据，默认展示20条序列。': '请注意：共{n}条数据，默认展示20条序列。',
  '告警等级({name})': '告警等级({name})',
  initYaml:
    // eslint-disable-next-line max-len
    'rules:\n  - alert: HighRequestLatency #规则名称,必填\n    expr: job:request_latency_seconds:mean5m{job="myjob"} > 0.5  #规则,必填\n    for: 10m #持续时间,选填。单位：m(分钟)或者h(小时)\n    labels:\n      severity: critical #告警等级,必填，枚举值：critical/warning/error\n      version: 1.0 # 用户自定义标签示例\n    annotations:\n      summary: High request latency #告警摘要,必填\n      description: High request latency #告警内容,必填\n      region: beijing # 用户自定义注解示例',
  '近{n}周': '近{n}周',
  '当前资源监控项维度最大支持勾选{max}个': '当前资源监控项维度最大支持勾选{max}个',
  '第{x}次调用': '第{x}次调用'
}

export default localDict
